import { API } from '../../shared/constants/constants';

interface FormData {
  userId: string;
  password?: string;
  phone?: string;
}

export type MFAMethod = 'SMS_MFA' | 'SOFTWARE_TOKEN_MFA';

interface MFAResponse {
  data: any;
  status?: number;
}

export const getUserMFAInfo = async (userId: string): Promise<MFAResponse> => {
  try {
    const res = await API.get(`/user/${userId}/mfaSettings`, {});
    return res.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message ?? 'Error occurred when getting MFA info');
  }
};

export const configUserMFA = async (formData: FormData, method: MFAMethod = 'SMS_MFA'): Promise<MFAResponse> => {
  try {
    const res = await API.patch(`/user/${formData.userId}/configmfa`, {
      method,
      password: formData.password,
      phone: formData.phone,
    });
    return res.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message ?? 'Error occurred when updating MFA info');
  }
};

export const validateUserMFACode = async (
  userId: string,
  session: string | null,
  code: string,
  method: MFAMethod = 'SMS_MFA'
): Promise<MFAResponse> => {
  try {
    const requestBody = { code, method, ...(session ? { session } : {}) };
    const res = await API.post(`/user/${userId}/validatemfa`, requestBody);
    return res.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message ?? 'Error occurred when validating MFA code');
  }
};

export const disableUserMFA = async (formData: FormData, method: MFAMethod = 'SMS_MFA'): Promise<MFAResponse> => {
  try {
    const res = await API.patch(`/user/${formData.userId}/disablemfa`, { method });
    return res.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message ?? 'Error occurred when validating MFA code');
  }
};

export const setPreferredUserMFA = async (userId: string, method: MFAMethod): Promise<MFAResponse> => {
  try {
    const res = await API.patch(`/user/${userId}/preferredmfa`, { method });
    return res.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message ?? 'Error occurred when updating preferred MFA method');
  }
};
